export default __webpack_public_path__ + "static/media/uts.d566d8ea.woff";